import {
  createInputFeature,
  ExtractFeaturePayload,
} from '@smartsheet-dataflow/formjs';
import { BridgeFormJSState } from '../Types';
import { dummyDispatch } from '../params/ParamFromSchema';

export const {
  actionCreator: setErrorAction,
  selectorCreator: errorSelector,
  featureReducer: ErrorFeature,
} = createInputFeature<'error', ErrorType>('error');

export type ErrorType = string;

export type ErrorState = {
  error: {
    [inputId: string]: string;
  };
};

export type ErrorPayload = ExtractFeaturePayload<typeof setErrorAction>;

export const reduceError =
  (payload: ErrorPayload) => (state: BridgeFormJSState) =>
    ErrorFeature(state, setErrorAction(dummyDispatch)(payload));
